import { DeploymentStatus } from '@/types/deployment'

const PAUSABLE = new Set<DeploymentStatus>([
  DeploymentStatus.Running,
  DeploymentStatus.Degraded
])

const RESUMABLE = new Set<DeploymentStatus>([DeploymentStatus.Stopped])

// Restart sets desired_state running on the backend, so it also starts a stopped group.
const RESTARTABLE = new Set<DeploymentStatus>([
  DeploymentStatus.Running,
  DeploymentStatus.Degraded,
  DeploymentStatus.Inactive,
  DeploymentStatus.Failed,
  DeploymentStatus.Recovering,
  DeploymentStatus.ConnectingVideoStream,
  DeploymentStatus.Stopped
])

export const canPauseGroup = (status: DeploymentStatus) => PAUSABLE.has(status)

export const canResumeGroup = (status: DeploymentStatus) =>
  RESUMABLE.has(status)

export const canRestartGroup = (status: DeploymentStatus) =>
  RESTARTABLE.has(status)
